import { ModalDialog } from '@/Components/ModalDialog/ModalDialog';
import React from 'react';
import { useLocalization, useShowGenerateDocumentNumberDialog } from '@/Hooks';
import { useSelector } from 'react-redux';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';

type Props = {
  onClose: () => void;
};

export function CreateDocumentModal({ onClose }: Props) {
  const {
    buttons: { Yes },
    modalWindows: {
      documentPrintModal: {
        CreateDocumentModal: { Title, Text },
      },
    },
  } = useLocalization();

  const { showGenerateDocumentNumberModal } = useShowGenerateDocumentNumberDialog();
  const documentType = useSelector(emailSendModalSelectors.documentType);

  return (
    <ModalDialog
      title={Title}
      text={Text}
      onNo={onClose}
      okButtonText={Yes}
      onOk={() => {
        if (documentType) {
          showGenerateDocumentNumberModal(documentType);
        }
      }}
    />
  );
}
